import React, { useState, useEffect } from "react";
import { FormControl, Select, MenuItem } from "@mui/material";
import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";

function SelfFullServiceFilter() {
  const [clientType, setClientType, removeClientType] =
    useCustomSearchParams("clientType");
  const [selectedValue, setSelectedValue] = useState(clientType || "");

  useEffect(() => {
    if (!clientType) {
      setSelectedValue("");
    }
  }, [clientType]);

  const options = [
    { label: "All Clients", value: "" },
    { label: "Self-Service Clients", value: "self-service" },
    { label: "Full-Service Clients", value: "full-service" },
  ];

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedValue(value);
    if (value) {
      setClientType("clientType", value);
    } else {
      removeClientType("clientType");
    }
  };

  return (
    <div className="input-select-box mr-2">
      <FormControl fullWidth className="filter-select">
        <Select
          sx={{
            height: "35px",
            minWidth: "100px",
            alignItems: "center",
            display: "flex",
            backgroundColor: clientType
              ? clientType === "self-service"
                ? "#DFFDFD"
                : "#FFF0EB"
              : "white",
          }}
          value={selectedValue}
          onChange={handleChange}
          displayEmpty
        >
          {options.map((option, index) => (
            <MenuItem
              key={index}
              value={option.value}
              className="dropdown-menu-options"
            >
              <p className="dropdown-options">{option.label}</p>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}

export default SelfFullServiceFilter;
